import "./index.css";

// Import app pages
import * as homePage from "./home";
// import * as projectsPage from "./projects";
import * as statisticsPage from "./statistics";
import * as customersPage from "./customers";
import * as blacklistsPage from "./blacklists";
import * as customerCustomFieldsPage from "./customerCustomFields";
import * as projectDashboardPage from "./projectPages/dashboard";
import * as projectCampaignsPage from "./projectPages/campaign";
import * as projectCustomersPage from "./projectPages/customers";
import * as projectCustomerGroupsPage from "./projectPages/customerGroups";
import * as projectCampaignPage from "./projectPages/campaign/pages/ItemPage";
import * as projectCappingPage from "./projectPages/capping";
import * as messagesPage from "./messages";
import * as messageDeliveriesPage from "./messageDeliveries";
import * as customerSegmentsPage from "./customerSegments";
import * as customerGroupsPage from './customerGroups';
// import * as usersPage from "./users";
// import * as rolesPage from "./roles";

import AppSectionComponentWithProjects from 'Components/AppSectionComponentWithProjects';
import * as appConfig from "./config";
import {appHasLogin} from "Core/helpers/login";

class DefaultApp extends AppSectionComponentWithProjects {
	constructor(props) {
		super(props, appConfig, {
			checkLogin: true,
			autoLogout: appHasLogin(),
			appPages: [
				homePage,
				// projectsPage,
				customersPage,
				statisticsPage,
				blacklistsPage,
				customerCustomFieldsPage,
				projectCampaignsPage,
				projectCampaignPage,
				projectCustomersPage,
				projectCustomerGroupsPage,
				projectCappingPage,
				projectDashboardPage,
				messagesPage,
				messageDeliveriesPage,
				customerSegmentsPage,
				customerGroupsPage,
				// usersPage,
				// rolesPage,
			],
		}, 'default-app');
	}

	render() {
		return this.renderApp();
	}
}

export * from "./config";
export default DefaultApp;